import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalBase } from '../modal-base.component';
import { DetailsModalData, ModalData } from '../../models';
import { Router } from '@angular/router';

@Component({
  selector: 'message-modal-with-details',
  templateUrl: './message-modal-with-details.component.html',
  styleUrls: [
    '../../../../../../assets/styles/components/modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageModalWithDetailsComponent extends ModalBase {

  details: string;

  constructor(protected dialogRef: MatDialogRef<MessageModalWithDetailsComponent>,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) public data: string | { message: string, title: string } | DetailsModalData) {
    super(data);
  }

  ok(): void {
    this.dialogRef.close();
  }

  public isInfoModalData(): boolean {
    return this.data instanceof ModalData;
  }

  public hasLink(): boolean {
    return this.data instanceof ModalData && !!this.data.link;
  }

  public goToLink(link: string) {
    const routerLink = link.split('/');
    this.ok();
    this.router.navigate(routerLink);
  }

  protected setMessages(data: string | { message: string, title: string } | DetailsModalData): void {
    if (data instanceof ModalData) {
      this.title = data.title;
      this.message = data.message;
      this.details = data.details;
      this.translateParams = data.translateParams;
      this.link = data.link;
    } else if (typeof data === 'string') {
      this.message = data;
    } else {
      this.message = data.message ? data.message : '';
      this.title = data.title ? data.title : '';
    }
  }

}
